import { errorMessage } from "../../lib/api";
import { toast } from "../../components/ui/Toast";
import { findMessage, removeMessage, restoreMessage } from "./cache";

/** How long Undo is offered before the delete is sent. */
const UNDO_MS = 6000;

/** Deletes waiting out their undo window, sent straight away if the page is closed. */
const pending = new Set<() => void>();
if (typeof window !== "undefined") window.addEventListener("pagehide", () => [...pending].forEach((flush) => flush()));

/**
 * Remove a message from view now and offer Undo, rather than asking first.
 * The delete is only sent once the undo window closes; if it fails, the
 * message comes back with an error.
 */
export function deleteMessageWithUndo(key: unknown[], id: string, commit: () => Promise<unknown>) {
  const msg = findMessage(key, id);
  removeMessage(key, id);
  let done = false;
  const flush = () => {
    if (done) return;
    done = true;
    clearTimeout(timer);
    pending.delete(flush);
    commit().catch((e) => {
      if (msg) restoreMessage(key, msg);
      toast.error(errorMessage(e, "Couldn't delete the message"));
    });
  };
  const timer = setTimeout(flush, UNDO_MS);
  pending.add(flush);
  toast.show(
    "Message deleted",
    {
      label: "Undo",
      onClick: () => {
        if (done) return;
        done = true;
        clearTimeout(timer);
        pending.delete(flush);
        if (msg) restoreMessage(key, msg);
      },
    },
    UNDO_MS,
  );
}
